export default "/images/vendor/flag-icon-css/flags/1x1/ky.svg?c311ddba04238d23214d3069072caea2";